'use client';

const AdBanner = ({ title, description, image, ctaText = "Learn More", variant = "default" }) => {
    return (
        <div className="group relative overflow-hidden rounded-2xl bg-white shadow-sm border border-slate-100 hover:shadow-md transition-all duration-300">
            {/* Image Background */}
            <div className="relative h-64 overflow-hidden">
                <img
                    src={image}
                    alt={title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

                {/* Sponsored Tag */}
                <div className="absolute top-3 right-3">
                    <span className="px-2 py-1 text-[10px] uppercase tracking-wider font-semibold text-white/80 bg-black/30 backdrop-blur-sm rounded-md border border-white/10">
                        Sponsored
                    </span>
                </div>

                {/* Content Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
                    <h3 className="text-xl font-bold mb-2 leading-tight">{title}</h3>
                    <p className="text-sm text-gray-200 mb-4 line-clamp-2">{description}</p>

                    <button className="w-full py-2.5 bg-white text-slate-900 text-sm font-semibold rounded-lg hover:bg-slate-50 active:scale-[0.98] transition-all">
                        {ctaText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdBanner;
